import React, { useEffect } from 'react';
import { useCreatePromoter } from '../../../editor/features/promote/PromotersPanel/use-create-promoter';

type Props = {
  botId: number;
  botRoute: string;
};

const CreateRemoteShareLink = (props: Props) => {
  const { botId } = props;
  const { createPromoter } = useCreatePromoter();

  useEffect(() => {
    createPromoter('link');
  }, [botId]);
  return <div />;
};

export default CreateRemoteShareLink;
